module.exports = __webpack_public_path__ + "img/icon_service_three.a8a1e2d0.svg";